<div class="card-container">
    <div class="title mb-2">
        Authenticator Test
    </div>
    <div class="content mb-3">
        <button class="mwp-button" (click)="pingExternalServers()">
            <mwp-text-translate text="Ping External Servers" jsonKey="pingExternalServer" />
        </button>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="content-container">
            <div class="title">
                <div class="d-inline-flex">
                    <div class="pe-2 pt-0">
                        External: Twilio Code Test
                    </div>
                    <div>
                        @if (!isLoaded) {
                            <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
                        }
                        @if (isLoaded && serverConnectionAuthModel.twilioServerConnected) {
                            <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
                        }
                        @if (isLoaded && !serverConnectionAuthModel.twilioServerConnected) {
                            <mwp-svg-icon [SvgMatType]="svgType.Error"  [SvgColor]="svgColor.error"/> 
                        }
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="row px-3">
                    <div class="col-4 ps-0">
                        <form [formGroup]="twilioForm" autocomplete="off">
                            <mwp-input [form]="twilioForm" labelName="Phone Number" nameForControl="phoneNumber" [maskType]="maskType.phone" />
                            <div class="mt-3">
                                <mwp-radio-button [form]="twilioForm" nameForControl="verificationType" [dataEnum]="twilioTypeEnum" [noSpacing]="true" />
                            </div>
                        </form>
                        <button class="mwp-button w-100 mt-3" [disabled]="twilioForm.invalid || twilioForm.disabled" (click)="testTwilioCode()">
                            <mwp-text-translate text="Submit" jsonKey="submit" />
                        </button>
                    </div>
                    <div class="col-4">
                        <form [formGroup]="twilioVerifyForm" autocomplete="off">
                            <div class="fw-bold d-flex justify-content-center">
                                Response Code
                            </div>
                            <div class="mt-3 d-flex justify-content-center">
                                <mwp-verify-code [form]="twilioVerifyForm" nameForRadioControl="verifyTwilioCode" [useFixedWidth]="true" />
                            </div>
                        </form>
                        <div class="d-flex justify-content-center">
                            <button class="mwp-button mt-3" [disabled]="twilioVerifyForm.invalid || twilioVerifyForm.disabled" (click)="verifyTwilioCode()">
                                <mwp-text-translate text="Verify Code" jsonKey="verifyCode" />
                            </button>
                        </div>
                    </div>
                    @if (twilioVerifyResponse) {
                        <div class="col-4 align-content-center">
                            @if (twilioVerifyResponse.isCodeVerified) {
                                <div class="message-card green d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
                                    <span class="ms-1">{{twilioVerifyResponse.returnMessage}}</span>
                                </div>
                                
                            } @else {
                                <div class="message-card red d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.Error"  [SvgColor]="svgColor.error"/> 
                                    <span class="ms-1 error">{{twilioVerifyResponse.returnMessage}}</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="content-container mb-3">
            <div class="title">
                Internal: Email Service Code
            </div>
            <div class="content">
                <div class="row px-3">
                    <div class="col-4 ps-0">
                        <form [formGroup]="internalForm" autocomplete="off">
                            <div>
                                <mwp-input [form]="internalForm" labelName="Email" nameForControl="email" />
                            </div>
                            <div class="mt-3">
                                <mwp-radio-button [form]="internalForm" nameForControl="verificationType" [dataEnum]="internalTypeEnum" [noSpacing]="true" />
                            </div>
                        </form>
                        <button class="mwp-button w-100 mt-3" [disabled]="internalForm.invalid || internalForm.disabled" (click)="testInternalCode()">
                            <mwp-text-translate text="Submit" jsonKey="submit" />
                        </button>
                    </div>
                    <div class="col-4">
                        <form [formGroup]="internalVerifyForm" autocomplete="off">
                            <div class="fw-bold d-flex justify-content-center">
                                Response Code
                            </div>
                            <div class="mt-3 d-flex justify-content-center">
                                <mwp-verify-code [form]="internalVerifyForm" nameForRadioControl="internalVerifyCode" [useFixedWidth]="true" />
                            </div>
                        </form>
                        <div class="d-flex justify-content-center">
                            <button class="mwp-button mt-3" [disabled]="internalVerifyForm.invalid || internalVerifyForm.disabled" (click)="verifyInternalCode()">
                                <mwp-text-translate text="Verify Code" jsonKey="verifyCode" />
                            </button>
                        </div>
                    </div>
                    @if (internalVerifyResponse) {
                        <div class="col-4 align-content-center">
                            @if (internalVerifyResponse.isCodeVerified) {
                                <div class="message-card green d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
                                    <span class="ms-1">{{internalVerifyResponse.returnMessage}}</span>
                                </div>
                                
                            } @else {
                                <div class="message-card red d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.Error"  [SvgColor]="svgColor.error"/> 
                                    <span class="ms-1 error">{{internalVerifyResponse.returnMessage}}</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
    

    <div class="col-12">
        <div class="content-container">
            <div class="title">
                <div class="d-inline-flex">
                    <div class="pe-2 pt-0">
                        Internal: QR Code Generator Test
                    </div>
                    <div>
                        @if (!isLoaded) {
                            <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
                        }
                        @if (isLoaded && serverConnectionAuthModel.googleQRGeneratorConnected) {
                            <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
                        }
                        @if (isLoaded && !serverConnectionAuthModel.googleQRGeneratorConnected) {
                            <mwp-svg-icon [SvgMatType]="svgType.Error"  [SvgColor]="svgColor.error"/> 
                        }
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="row px-3">
                    <div class="col-3 ps-0">
                        <form [formGroup]="QRForm" autocomplete="off">
                            <div>
                                <mwp-input [form]="QRForm" labelName="Email" nameForControl="email" />
                            </div>
                            <div class="mt-3">
                                <mwp-radio-button [form]="QRForm" nameForControl="verificationType" [dataEnum]="internalTypeEnum" [noSpacing]="true" />
                            </div>
                        </form>
                        <button class="mwp-button w-100 mt-3" [disabled]="QRForm.invalid || QRForm.disabled" (click)="generateQRCode()">
                            <mwp-text-translate text="Generate QR Code" jsonKey="generateQRCode" />
                        </button>
                    </div>
                    <div class="col-5 d-inline-flex">
                        <div class="me-3">
                            <div class="fw-bold d-flex justify-content-center">
                                QR Code:
                            </div>
                            <div>
                                @if (AuthenticatorQR) {
                                    <img [src]="AuthenticatorQR.qrCodeUrl"  style="width: 200px; height: 200px; image-rendering: pixelated;"/>
                                }
                            </div>
                        </div>
                        <div class="me-3">
                            <div class="fw-bold d-inline-flex">
                                Manual Entry Code: 
                            </div>
                            <div>
                                @if (AuthenticatorQR) {
                                    {{AuthenticatorQR.manualEntryKey}}
                                }
                            </div>
                        </div>
                        <div>
                            <form [formGroup]="QRVerifyForm" autocomplete="off">
                                <div class="fw-bold d-flex justify-content-center">
                                    Response Code
                                </div>
                                <div class="mt-3 d-flex justify-content-center">
                                    <mwp-verify-code [form]="QRVerifyForm" nameForRadioControl="qrVerifyCode" [useFixedWidth]="true" />
                                </div>
                            </form>
                            <div class="d-flex justify-content-center">
                                <button class="mwp-button mt-3" [disabled]="QRVerifyForm.invalid || QRVerifyForm.disabled" (click)="verifyQRCode()">
                                    <mwp-text-translate text="Verify Code" jsonKey="verifyCode" />
                                </button>
                            </div>
                        </div>
                    </div>
                    @if (QRVerifyResponse) {
                        <div class="col-4 align-content-center">
                            @if (QRVerifyResponse.isCodeVerified) {
                                <div class="message-card green d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
                                    <span class="ms-1">{{QRVerifyResponse.returnMessage}}</span>
                                </div>
                                
                            } @else {
                                <div class="message-card red d-inline-flex">
                                    <mwp-svg-icon [SvgMatType]="svgType.Error"  [SvgColor]="svgColor.error"/> 
                                    <span class="ms-1 error">{{QRVerifyResponse.returnMessage}}</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>